export const initReviewRatings = () => {
  const reviewRatings = document.querySelectorAll('.js-review-rating');

  reviewRatings.forEach((rating) => {
    const rawValue = parseFloat(rating.dataset.rating || '0');
    const value = Number.isFinite(rawValue) ? Math.min(5, Math.max(0, rawValue)) : 0;

    rating.style.setProperty('--rating', String(value));
    rating.setAttribute('aria-label', `${value} з 5`);
  });
};
